module.exports = __webpack_public_path__ + "img/xingguang.1f57b5cc.png";